import AuthLayout from '../components/AuthLayout';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ForgotPasswordPage: React.FC = () => {
  const [companyCode, setCompanyCode] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccess(false);

    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000';
      await axios.post(`${apiUrl}/auth/forgot-password`, {
        companyCode,
        email
      });

      setSuccess(true);
      setCompanyCode('');
      setEmail('');
    } catch (error: any) {
      setError(error.response?.data?.error || 'パスワードリセット申請に失敗しました');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout title="パスワードの再設定"
      description="ご登録のメールアドレス宛に、再設定用のリンクをお送りします。">

      {error && (
        <div style={{ color: 'red', marginBottom: '20px', padding: '10px', border: '1px solid red', borderRadius: '4px' }}>
          {error}
        </div>
      )}

      {success ? (
        <div>
          <div style={{ color: 'green', marginBottom: '20px', padding: '10px', border: '1px solid green', borderRadius: '4px' }}>
            パスワードリセットのメールを送信しました。<strong>登録されているメールアドレスの場合は</strong>メールが届きます。<br />
            数分待ってもメールが届かない場合は、メールアドレスが正しいか、または迷惑メールフォルダを確認してください。
          </div>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Link to="/login" style={{ color: '#2563EB' }}>ログイン画面に戻る</Link>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <p style={{ marginBottom: '20px', color: '#666' }}>
            登録されているメールアドレスにパスワードリセット用のリンクを送信します。
          </p>

          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="companyCode">企業コード:</label>
            <input
              type="text"
              id="companyCode"
              value={companyCode}
              onChange={(e) => setCompanyCode(e.target.value.toUpperCase())}
              required
              maxLength={6}
              placeholder="例: ABC123"
              style={{ width: '100%', padding: '8px', marginTop: '5px', textTransform: 'uppercase' }}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="email">メールアドレス:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="例: user@example.com"
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#2563EB',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              marginBottom: '15px'
            }}
          >
            {isLoading ? '送信中...' : 'リセットメールを送信'}
          </button>

          <div style={{ textAlign: 'center' }}>
            <Link to="/login" style={{ color: '#2563EB' }}>ログイン画面に戻る</Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
